import { makeRequest } from './Storefront'

const customerResponse = `
  id
  firstName
  lastName
  acceptsMarketing
  email
  phone
  tags
  birth: metafield(namespace: "custom", key: "birth") {
    id
    value
  }
  country: metafield(namespace: "custom", key: "country") {
    id
    value
  }
  shoppingPreferences: metafield(namespace: "custom", key: "shopping_preferences") {
    id
    value
  }
  additionalInfo: metafield(namespace: "custom", key: "address_additional_info") {
    id
    value
  }
  crmId: metafield(namespace: "sfc", key: "crm_id") {
    id
    value
  }
  crmCampaigns: metafield(namespace: "sfc", key: "crm_campaigns") {
    id
    value
  }
`
export const tokenCreate = (callback = null, email, password) => {
  const query = `
    mutation customerAccessTokenCreate {
      customerAccessTokenCreate(input: {email: "${email}", password: "${password}"}) {
        customerAccessToken {
          accessToken
        }
        customerUserErrors {
          message
        }
      }
    }
  `
  makeRequest((results) => {
    callback(results.data?.customerAccessTokenCreate?.customerAccessToken?.accessToken)
  }, query)
}

export const getCustomer = (callback = null, token) => {
  const query = `
    query {
      customer(customerAccessToken: "${token}") {
        ${customerResponse}
      }
    }
  `
  makeRequest((results) => {
    callback(results.data?.customer)
  }, query)
}

export const customerUpdate = (callback = null, token, customer = {}) => {
  const query = `
    mutation customerUpdate($customer: CustomerUpdateInput!, $customerAccessToken: String!) {
      customerUpdate(customer: $customer, customerAccessToken: $customerAccessToken) {
        customer {
          ${customerResponse}
        }
        customerUserErrors {
          code
          field
          message
        }
        userErrors {
          field
          message
        }
      }
    }
  `
  makeRequest(
    (results) => {
      callback(results.data?.customerUpdate)
    },
    query,
    {
      customer,
      customerAccessToken: token,
    },
  )
}
export const customerGetByAdmin = (callback = null, email) => {
  fetch(`https://${window.tbApiDomain}/get_customer?email=${email}`)
    .then(res=> res.json())
    .then(res => {
      if(callback) callback(res)
    })
}
export const customerCreateByAdmin = (callback = null, data) => {

  // Add locale information to customer data
  if(data.customer) data.customer.language = window.Shopify.locale;

  fetch(`https://${window.tbApiDomain}/create_customer`, {
    method: 'POST',
    headers: new Headers({
      'Content-Type': 'application/json',
      Accept: 'application/json',
    }),
    body: JSON.stringify(data),
  })
    .then((response) => response.json())
    .then((data) => {
      console.log('api customer create', data)
      callback(data)
    })
    .catch((e) => {
      console.error(e)
    })
}
export const locationUpdate = (callback = null, data) => {
  fetch(`https://${window.tbApiDomain}/update_location`, {
    method: 'POST',
    headers: new Headers({
      'Content-Type': 'application/json',
      Accept: 'application/json',
    }),
    body: JSON.stringify(data),
  })
    .then((response) => response.json())
    .then((data) => {
      console.log('api data', data)
      callback(data)
    })
    .catch((e) => {
      console.error(e)
    })
}
export const searchOrder = (callback = null, data) => {
  fetch(`https://${window.tbApiDomain}/search_order_by_number`, {
    method: 'POST',
    headers: new Headers({
      'Content-Type': 'application/json',
      Accept: 'application/json',
    }),
    body: JSON.stringify(data),
  })
    .then((response) => response.json())
    .then((data) => {
      console.log('api data', data)
      callback(data)
    })
    .catch((e) => {
      console.error(e)
    })
}
export const formatOrder = (apiOrder) => {
  return {
    id: apiOrder?.id?.replace('gid://shopify/Order/', ''),
    email: apiOrder?.email,
    name: apiOrder?.name,
    createdAt: apiOrder?.createdAt,
    line_items: apiOrder?.lineItems?.edges?.map(edge => {
      return {
        id: edge.node.id.replace('gid://shopify/LineItem/', ''),
        id_full: edge.node.id,
        image: edge.node.image?.url,
        final_line_price: edge.node.discountedTotalSet.presentmentMoney.amount,
        original_line_price: edge.node.originalTotalSet.presentmentMoney.amount,
        quantity: edge.node.quantity,
        variant: {
          option1: edge.node.variant.selectedOptions[0]?.value,
          option2: edge.node.variant.selectedOptions[1]?.value,
        },
        currentQuantity: edge.node.currentQuantity,
        refundableQuantity: edge.node.refundableQuantity,
        isFinalSale: edge.node.isFinalSale
      }
    }),
    fulfillments : apiOrder?.fulfillments,
  }
}
export const sendInviteEmailByAdmin = (callback = null, data) => {
  fetch(`https://${window.tbApiDomain}/account_invite_email`, {
    method: 'POST',
    headers: new Headers({
      'Content-Type': 'application/json',
      Accept: 'application/json',
    }),
    body: JSON.stringify(data),
  })
    .then((response) => response.json())
    .then((data) => {
      console.log('api invite email', data)
      callback(data)
    })
    .catch((e) => {
      console.error(e)
    })
}
export const customerUpdateByAdmin = (callback = null, data) => {
  fetch(`https://${window.tbApiDomain}/update_customer`, {
    method: 'POST',
    headers: new Headers({
      'Content-Type': 'application/json',
      Accept: 'application/json',
    }),
    body: JSON.stringify(data),
  })
    .then((response) => response.json())
    .then((data) => {
      console.log('api customer', data.customer)
      callback(data.customer)
    })
    .catch((e) => {
      console.error(e)
    })
}

export const updateMarketingConsent = (callback = null, data) => {
  fetch(`https://${window.tbApiDomain}/update_marketing_consent`, {
    method: 'POST',
    headers: new Headers({
      'Content-Type': 'application/json',
      Accept: 'application/json',
    }),
    body: JSON.stringify(data),
  })
    .then((response) => response.json())
    .then((data) => {
      console.log('api customer', data.customer)
      callback(data.customer)
    })
    .catch((e) => {
      console.error(e)
    })
}

// Lead form middleware - used to update existing customer with campaign data
// Called from CampaignUpdate.jsx after login redirect
export const leadFormUpdate = (callback = null, data) => {
  fetch(window.leadFormEndpoint, {
    method: 'POST',
    headers: new Headers({
      'Content-Type': 'application/json',
      Accept: 'application/json',
      'x-api-key': window.leadFormApiKey,
    }),
    body: JSON.stringify({
      event: {
        source: "Shopify",
        channel: "Shopify",
        name: "Customer.associateCampaign",
      },
      body: data,
    }),
  })
    .then((response) => response.json())
    .then((data) => {
      console.log('api lead form update', data)
      if(callback) callback(data)
    })
    .catch((e) => {
      console.error(e)
    })
}